import { render } from "./CourseStructure.vue?vue&type=template&id=1f7bb149&scoped=true"
import script from "./CourseStructure.vue?vue&type=script&lang=js"
export * from "./CourseStructure.vue?vue&type=script&lang=js"

import "./CourseStructure.vue?vue&type=style&index=0&id=1f7bb149&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7bb149"]])

export default __exports__